// Utilities
import { mapState } from 'vuex'
import Authorization from 'Mixins/Authorization'
// Components
import TheTopbarNavbarMenuItem from '../components/TheTopbarNavbarMenuItem'

export default {
  components: {
    TheTopbarNavbarMenuItem,
  },

  mixins: [Authorization],

  methods: {
    goToMenu(component) {
      this.$emit('menu-selected', component)
    },
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.user.currentUser,
      currentAccount: (state) => state.client.account || null,
    }),
  },

  async mounted() {
    await this.$nextTick().then(() => {
      const height = this.$el.scrollHeight + 20
      this.$el.parentElement.style.height = height + 'px'
    })
  },
}
